/* SharpShine products with filter — task P1-10 (reference: prototype/ss-home.js, setFilter). Loaded by sections/ss-product-tabs.liquid.
   - A button shows its collection's cards: the first grid is in the page, the others come out of their <template> the
     first time (so their photos load only then) and are kept. The cards themselves work through assets/ss-card.js.
   - A dark pill slides to the pressed button; on phones the button row scrolls the pressed one into view.
   - Links marked data-ss-go="<collection handle>" (the bento hero's cards, its green button with "ss-all") jump here
     and press the matching button instead of leaving the page; without a match they stay normal links.
   - The "View all" link, the note under the grid and a screen-reader message follow the pressed button.
   No visible words live in this file: they come from the markup (data-name, data-more-label, data-note, locales ss.home.*). */
(function () {
  'use strict';
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function pill(box, instant) {
    var bar = box.querySelector('.ss-tabs__bar'), p = bar && bar.querySelector('.ss-tabs__pill'), b = bar && bar.querySelector('[aria-pressed="true"]');
    if (!p || !b) return;
    p.classList.toggle('is-instant', !!instant);
    p.style.width = b.offsetWidth + 'px';
    p.style.height = b.offsetHeight + 'px';
    p.style.transform = 'translate(' + b.offsetLeft + 'px,' + b.offsetTop + 'px)';
    bar.classList.add('has-pill');
  }

  function show(box, i, announce) {
    var btns = $$('[data-ss-tab]', box), btn = btns[i];
    if (!btn || btn.getAttribute('aria-pressed') === 'true') return btn;
    btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    pill(box, reduceMQ.matches);
    var bar = box.querySelector('.ss-tabs__bar');
    if (bar && bar.scrollWidth > bar.clientWidth) bar.scrollTo({ left: btn.offsetLeft - (bar.clientWidth - btn.offsetWidth) / 2, behavior: reduceMQ.matches ? 'auto' : 'smooth' });

    var panels = box.querySelector('.ss-tabs__panels'), grid = panels.querySelector('ul[data-ss-panel="' + i + '"]');
    if (!grid) {
      var tpl = panels.querySelector('template[data-ss-panel="' + i + '"]');
      if (!tpl) return btn;
      grid = tpl.content.firstElementChild.cloneNode(true);
      panels.appendChild(grid);
    }
    $$('ul[data-ss-panel]', panels).forEach(function (g) { g.hidden = g !== grid; });
    grid.classList.remove('is-entering'); void grid.offsetWidth; grid.classList.add('is-entering'); // cards rise in one after another (CSS)

    var more = box.querySelector('[data-ss-tabs-more]'), note = box.querySelector('[data-ss-tabs-note]');
    if (more && btn.dataset.moreUrl) { more.href = btn.dataset.moreUrl; more.firstElementChild.textContent = btn.dataset.moreLabel; }
    if (note) note.textContent = btn.dataset.note || '';
    if (announce) {
      var live = box.querySelector('[data-ss-tabs-live]');
      if (live) { live.textContent = ''; setTimeout(function () { live.textContent = live.dataset.tpl ? live.dataset.tpl.replace('%%', btn.dataset.name) : btn.dataset.name; }, 60); }
    }
    return btn;
  }

  function init(box) {
    if (box._ssTabs) return;
    box._ssTabs = true;
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ss-tab]');
      if (b) show(box, +b.dataset.ssTab, true);
    });
    if (window.ResizeObserver) new ResizeObserver(function () { pill(box, true); }).observe(box.querySelector('.ss-tabs__bar') || box);
    requestAnimationFrame(function () { pill(box, true); });
  }

  /* Jumps from the hero: press the button whose collection matches, then scroll to the products. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ss-go]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var handle = a.dataset.ssGo, hit = null, box = null;
    $$('[data-ss-tabs]').some(function (bx) {
      return $$('[data-ss-tab]', bx).some(function (b) {
        if ((' ' + b.dataset.handle + ' ').indexOf(' ' + handle + ' ') < 0) return false;
        hit = b; box = bx; return true;
      });
    });
    if (!hit) return;
    e.preventDefault();
    show(box, +hit.dataset.ssTab, true);
    box.scrollIntoView({ behavior: reduceMQ.matches ? 'auto' : 'smooth', block: 'start' });
    setTimeout(function () { hit.focus({ preventScroll: true }); }, reduceMQ.matches ? 0 : 700);
  });

  function start(scope) { $$('[data-ss-tabs]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); }); else start(document);
  /* Theme editor: a reloaded section starts again; picking a button block shows its products. */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target.closest && e.target.closest('[data-ss-tab]'), box = b && b.closest('[data-ss-tabs]');
    if (box) show(box, +b.dataset.ssTab, false);
  });
})();
